// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { ExpandDoubleVector } from "./DoubleMatrix.js";
import { ResVector } from "./ResVector.js";

export let ConstantVector = function (value, rowNumber, timeShift, priceMult)
{
    ResVector.call(this, rowNumber, timeShift, priceMult, new ExpandDoubleVector());
    this.FVector = new FreezedVector(0);
    this.FValue = value;
    this.isConstantVector = true;
}

ConstantVector.prototype = Object.create(ResVector.prototype);

Object.defineProperty(ConstantVector.prototype, 'Value',
    {
        get: function () { return this.FValue },
        set: function (value) { this.FValue = value }
    })

Object.defineProperty(ConstantVector.prototype, 'RowNumber',
    {
        get: function () { return this.FRowNumber },

    })

//#region IDoubleVector Members
ConstantVector.prototype.get = function (index)
{
    return this.FValue;
}
ConstantVector.prototype.set = function (index, value)
{

}
//#endregion


export let FreezedVector = function (count)
{
    ExpandDoubleVector.call(this);
    this.FCount = count || 0;
}

FreezedVector.prototype = Object.create(ExpandDoubleVector.prototype);

FreezedVector.prototype.Add = function (value)
{
    this.FCount++;
}

FreezedVector.prototype.Clear = function ()
{
    this.FCount = 0;
}

Object.defineProperty(FreezedVector.prototype, "Length",
    {
        get: function () { return this.FCount; },
        set: function (value) { this.FCount = value }
    });

FreezedVector.prototype.get = function (index)
{
    return 0;
}
FreezedVector.prototype.set = function (index, value)
{

}
